import { useEffect, useState } from "react";
import { opApi } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { ApptCard } from "@/components/mc/appt/ApptCard";

// "Find a booking" — for calls and walk-ins who don't know who they're seeing.
export function ApptSearch({ viewer, onStatus, refreshKey }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  useEffect(() => {
    if (q.trim().length < 2) { setRows(null); return; }
    const h = setTimeout(() => opApi.get("/tenant/appointments/search", { params: { q } }).then(({ data }) => setRows(data)).catch(() => setRows([])), 250);
    return () => clearTimeout(h);
  }, [q, refreshKey]);
  return (
    <div data-testid="appt-search">
      <div className="relative">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input className="rounded-none pl-9" placeholder="Find a booking — client name, phone or reference (AP-…)" value={q} onChange={(e) => setQ(e.target.value)} data-testid="appt-search-input" />
      </div>
      {rows && (
        <div className="border border-t-0 border-border divide-y max-h-96 overflow-auto" data-testid="appt-search-results">
          {rows.length === 0 && <div className="p-4 text-sm text-muted-foreground" data-testid="appt-search-empty">No upcoming bookings match “{q}”.</div>}
          {rows.map((a) => <ApptCard key={a.id} a={a} viewer={viewer} onStatus={onStatus} showDate showProvider />)}
        </div>
      )}
    </div>
  );
}
